import {
  getRuntimeMode,
  isIosNativeAppRuntime,
  openExternalUrl,
  type RuntimeMode,
} from './runtimeCapabilities';

export interface GpsUnsupportedAccessCopy {
  title: string;
  message: string;
  chromeDemoContext: string;
  actionLabel: string;
  url: string;
  mode: RuntimeMode;
}

export const GPS_SUPPORT_URL = 'mailto:support@ziawellnav.com?subject=ZiaWellNav%20Location%20Support';

const GPS_UNSUPPORTED_PATTERNS = [
  /gps\s+(is\s+)?not\s+supported/i,
  /gps.*unsupported/i,
  /unsupported.*gps/i,
  /geolocation\s+(is\s+)?not\s+supported/i,
  /geolocation.*unsupported/i,
  /unsupported.*geolocation/i,
  /geolocation api unavailable/i,
  /location sharing not supported/i,
];

const valueText = (value: unknown): string => {
  if (typeof value === 'string') return value;
  if (value instanceof Error) return value.message;
  if (!value || typeof value !== 'object') return '';
  const maybePayload = value as { reason?: unknown; message?: unknown; error?: unknown };
  return [maybePayload.reason, maybePayload.message, maybePayload.error]
    .filter((part): part is string => typeof part === 'string')
    .join(' ');
};

export function isGpsUnsupportedMessage(value: unknown): boolean {
  if (isIosNativeAppRuntime()) return false;

  const text = valueText(value);
  if (!text) return false;
  if (/denied|permission|blocked by user/i.test(text)) return false;
  return GPS_UNSUPPORTED_PATTERNS.some((pattern) => pattern.test(text));
}

export function formatGpsUnsupportedAccess(_source?: unknown): GpsUnsupportedAccessCopy {
  return {
    title: 'Location Support',
    message: 'This device or browser did not provide GPS. Use the native iOS app with Location Services enabled, or contact support if location still fails.',
    chromeDemoContext: 'ZiaWellNav can still search wells and facilities without GPS; live navigation needs Location Services.',
    actionLabel: 'Contact Support',
    url: GPS_SUPPORT_URL,
    mode: getRuntimeMode(),
  };
}

export function openGpsUnsupportedHelp(url = GPS_SUPPORT_URL) {
  return openExternalUrl(url, { tryHostBridge: false });
}
